import React from 'react';

interface GoalsContextType {
  loadingGoals: boolean;
  // Active (non-archived) goals. Does not include goals with isHidden: true.
  goals: GeneralGoal[];
  // Goals with isHidden: true. Only exposed for the staff-only Archived view.
  archivedGoals: GeneralGoal[];
  goalMetrics: { label: string; id: string }[];
  updateGoal: (newGoal: GeneralGoal) => Promise<void>;
  deleteGoal: (goalId: string) => Promise<void>;
}

const GoalsContext = React.createContext<GoalsContextType>({
  goals: [],
  archivedGoals: [],
  goalMetrics: [],
  loadingGoals: true,
  updateGoal: async () => {},
  deleteGoal: async () => {},
});

export default GoalsContext;
